import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FichasComponent } from './fichas/fichas.component';

const routes: Routes = [
  { path:  'fichas', component: FichasComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
